import { slideToggle } from '../helpers.js';

/**
 * The accordion logic for the content filters.
 */
const initFilterAccordion = () => {
	const title = document.querySelector('.em-filterable-content__title');
	const accordion = document.querySelector('.em-filterable-content__accordion');
	const handleToggle = () => {
		title.classList.toggle('active');
		slideToggle(accordion);
	};

	if (title) {
		title.addEventListener('click', handleToggle);
		title.addEventListener('keyup', (e) => {
			if (e.code === 'Enter') {
				handleToggle();
			}
		});
	}
};

export default initFilterAccordion;
